import { Button } from '@udemy/react-core-components';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import styles from "./link-group.module.css";

/**
 * ### LinkGroup
 *
 * @remarks
 * This is essentially a stylized unordered list (`ul`).
 */
export const LinkGroup = _ref => {
  let {
    ariaLabel,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", Object.assign({
    role: "navigation",
    "aria-label": ariaLabel
  }, props, {
    className: classNames('ud-unstyled-list', styles.group, props.className)
  }), React.Children.toArray(children).map((child, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, child)));
};
/**
 * ### LinkGroupItem
 *
 * @remarks
 * This will render a {@link Button} component with the `componentClass` property set to `a` and a default size of `small`.
 *
 */

export const LinkGroupItem = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    size = 'small',
    componentClass = 'a',
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    ref: ref,
    size: size,
    componentClass: componentClass
  }, props, {
    udStyle: "secondary",
    className: styles.item
  }));
});
LinkGroupItem.displayName = 'LinkGroupItem';
LinkGroup.Item = LinkGroupItem;
//# sourceMappingURL=link-group.react-component.js.map